/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getModelTypesList, getModelName } from "data/resources/model-items-config";
import { Select, MenuItem, Switch } from "@mui/material";
import { getCategory, getSelectedCategoryName } from "data/resources/model-category-options";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { Logger } from "cms/utils/log/logger";

const FeedModelComponentEditor = () => {

    const { component, update } = useUpdateComponent();
    const {
        selected_type,
        selected_category,
        enable_bar
    } = component || {};

    const model_types = getModelTypesList();
    const category_types = getCategory(selected_type);

    const onChangeType = (event) => {
        const selectedType = event.target.value;
        update("selected_type", selectedType);
    };

    const onChangeCategory = (event) => {
        let nextCategory = event.target.value;
        if (nextCategory === "none") {
            nextCategory = undefined;
        }
        update("selected_category", nextCategory);
    };

    const onChangeToggle = (event) => {
        let nextChecked = event.target.checked;
        Logger.debug(`Toggle state: ${nextChecked}`);
        update("enable_bar", nextChecked);
    };

    return (
        <div className='simplicity-editor-frame'>
            <h2>Selected Model: {getModelName(selected_type)}</h2>
            <Select
                labelId={"category_label"}
                id='category-select'
                sx={{ width: "400px" }}
                value={selected_type || ""}
                onChange={onChangeType}
            >
                <MenuItem key='none' value='none'>Select One...</MenuItem>
                {model_types.map((type, index) => (
                    <MenuItem key={index} value={type.type}>{type.name}</MenuItem>
                ))}
            </Select>

            <h3>Selected Category: {getSelectedCategoryName(selected_type, selected_category)}</h3>
            <Select
                labelId={"category_label"}
                id="category-select"
                sx={{ width: "400px" }}
                value={selected_category || ""}
                onChange={onChangeCategory}
            >
                {category_types.map((category, index) => (
                    <MenuItem key={index} value={category.value}>{category.label}</MenuItem>
                ))}
            </Select>

            <h3>Enable Search/Filter Bar:</h3>
            <Switch
                onChange={onChangeToggle}
                checked={enable_bar ?? false}
            />
        </div>
    );
};
FeedModelComponentEditor.displayName = "FeedModelComponentEditor";
export { FeedModelComponentEditor };
